import { ISidebarModel, SidebarEnum } from "../tsmodels/RoutesModel";

import { ReactComponent as QuestionnairesIcon } from "../images/questionnaire-icon.svg"
import { ReactComponent as QuestionnairesActiveIcon } from "../images/questionnaire-active-icon.svg"
import { ReactComponent as DocumentsIcon } from "../images/documents-icon.svg"
import { ReactComponent as DocumentsActiveIcon } from "../images/documents-active-icon.svg"
import { ReactComponent as MappingsIcon } from "../images/mappings-icon.svg"
import { ReactComponent as MappingsActiveIcon } from "../images/mappings-active-icon.svg"

export const sidebarIconsConfig: ISidebarModel[] = [
  {
    link: SidebarEnum.DOCUMENTS,
    linkName: SidebarEnum.DOCUMENTS,
    url: SidebarEnum.DOCUMENTS,
    icon: <DocumentsIcon />,
    activeIcon: <DocumentsActiveIcon />
  },
  {
    link: SidebarEnum.QUESTIONNAIRE,
    linkName: SidebarEnum.QUESTIONNAIRE,
    url: SidebarEnum.QUESTIONNAIRE,
    icon: <QuestionnairesIcon />,
    activeIcon: <QuestionnairesActiveIcon />
  },
  {
    link: SidebarEnum.MAPPINGS,
    linkName: SidebarEnum.MAPPINGS,
    url: SidebarEnum.MAPPINGS,
    icon: <MappingsIcon />,
    activeIcon: <MappingsActiveIcon />
  },
]

export const getSidebarIcon = (link: SidebarEnum) => {
  const element = sidebarIconsConfig?.find(each => each?.link === link)
  if (element?.icon) {
    return element?.icon
  } return <></>
}

